import { useState, useEffect } from "react";
import { API_BASE_URL } from "../../../config";
import LoadingScreen from "../../common/LoadingScreen";
import AlphabetGrid from "./AlphabetGrid";
import AlphabetPractice from "./AlphabetPractice";
import "../../../assets/css/alphabet.css";

const LANG_TAG = { 0: "de-DE", 1: "es-MX", 2: "fr-FR", 3: "ru-RU", 4: "pt-BR" };
function getLangTag(langId) { return LANG_TAG[parseInt(langId, 10)] ?? "de-DE"; }

function AlphabetDash({ lang_id }) {
    const [letters, setLetters] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [activeTab, setActiveTab] = useState("learn"); // "learn" or "practice"

    useEffect(() => {
        setLoading(true);
        setError(null);
        fetch(`${API_BASE_URL}/api/alphabet?lang_id=${lang_id}`)
            .then(res => {
                if (!res.ok) throw new Error("Failed to load alphabet data.");
                return res.json();
            })
            .then(data => {
                setLetters(data.letters || []);
            })
            .catch(err => {
                console.error(err);
                setError(err.message || "An error occurred.");
            })
            .finally(() => {
                setLoading(false);
            });
    }, [lang_id]);

    if (loading) {
        return <LoadingScreen inline title="Loading alphabet..." size={50} />;
    }

    if (error) {
        return (
            <div className="alphabet-error-container">
                <p className="alphabet-error-text">{error}</p>
                <button className="alphabet-retry-btn" onClick={() => window.location.reload()}>Retry</button>
            </div>
        );
    }

    if (letters.length === 0) {
        return (
            <div className="alphabet-empty-container">
                <p>No alphabet letters registered for this language yet.</p>
            </div>
        );
    }

    const langTag = getLangTag(lang_id);

    return (
        <div className="alphabet-dash-root">
            <div className="alphabet-tabs">
                <button
                    className={`alphabet-tab-btn ${activeTab === "learn" ? "alphabet-tab-btn--active" : ""}`}
                    onClick={() => setActiveTab("learn")}
                >
                    Learn Chart
                </button>
                <button
                    className={`alphabet-tab-btn ${activeTab === "practice" ? "alphabet-tab-btn--active" : ""}`}
                    onClick={() => setActiveTab("practice")}
                >
                    Practice
                </button>
            </div>

            <div className="alphabet-tab-content">
                {activeTab === "learn" ? (
                    <AlphabetGrid letters={letters} langTag={langTag} lang_id={lang_id} />
                ) : (
                    <AlphabetPractice letters={letters} langTag={langTag} lang_id={lang_id} />
                )}
            </div>
        </div>
    );
}

export default AlphabetDash;
